const styles = theme => ({
  skeletonRow: {
    padding: '12px 8px',
  },
  skeletonLine1: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '8px',
  },
  skeletonIcon: {
    marginRight: '8px',
    flexShrink: 0,
  },
  skeletonText: {
    marginLeft: '8px',
  },
  skeletonLine2: {
    display: 'flex',
    gap: '8px',
    marginLeft: '36px',
  },
})

export default styles
